import { render, staticRenderFns } from "./SurveyWelcome.vue?vue&type=template&id=3ad7f13a&"
import script from "./SurveyWelcome.vue?vue&type=script&lang=ts&"
export * from "./SurveyWelcome.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports